import { useToast } from '@chakra-ui/react'
import { useMutation, useQuery } from 'react-query'
import { DadosOrcamentoPedidoService } from '../service/dados-orcamento-pedido-service'
import { useParams } from 'react-router-dom'

const dadosOrcamentoPedido = new DadosOrcamentoPedidoService()

export const useDadosOrcamentoPedido = () => {
  const { numeroProposta: numProposta } = useParams()

  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })

  const { mutateAsync: solicitarCaricatura, isLoading: solicitarCaricaturaLoading } = useMutation({
    mutationFn: (data) => dadosOrcamentoPedido.solicitarCaricatura(data),
    onSuccess: () => {
      toast({
        title: 'Caricatura solicitada com sucesso',
        status: 'success',
      })
    },
    onError: (error) => {
      toast({
        title: 'Erro ao solicitar caricatura',
        description: error.response.data.erros,
        status: 'error',
      })
    },
  })

  const {
    data: {
      itens = [],
      informacao_da_proposta: infoProposta = {
        empresas: [],
        tipos_funil: [],
        tipos_verba: [],
        historico_pagamento: [],
        cliente: {},
      },
    } = {},
    isLoading,
    refetch,
    isRefetching,
    isError,
  } = useQuery({
    queryKey: ['items', numProposta],
    queryFn: () => dadosOrcamentoPedido.getItems({ numeroProposta: numProposta }),
    onError: (error) => {
      toast({
        title: 'Erro ao buscar informações da proposta',
        description: 'Tente novamente mais tarde',
        status: 'error',
      })
    },
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
  })

  return { isLoading, infoProposta, itens, refetch, isRefetching, isError, solicitarCaricatura, solicitarCaricaturaLoading }
}

//exampel setQueryData
// import { useMutation, useQuery, useQueryClient } from 'react-query';
// import { formatPrice } from '../../../../../../utils/formatPrice';
